
import {MarkNodeUpdatedBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-node-updated-behavior';
import {MarkNodeAddedBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-node-added-behavior';
import {MarkElementDeletedBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-element-deleted/behaviors/mark-element-deleted-behavior';
import {TrackingChangesRenderer} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/tracking-changes-renderer';
import {MarkNodeDeletedHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-element-deleted/handlers/mark-node-deleted-handler";
import {MarkConnectionDeletedHandler} from "@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-element-deleted/handlers/mark-connection-deleted-handler";
import {MarkConnectionAddedBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/mark-connection-added-behavior";

export const ModelerTrackingChangesExtensionModule = {
    __init__: ['markNodeAddedBehavior', 'markNodeUpdatedBehavior', 'bpmnRenderer', 'markElementDeletedBehavior',
    'markNodeDeletedHandler', 'markConnectionDeletedHandler','markConnectionAddedBehavior'],
    markNodeUpdatedBehavior: ['type', MarkNodeUpdatedBehavior],
    markNodeAddedBehavior: ['type', MarkNodeAddedBehavior],
    markConnectionAddedBehavior: ['type', MarkConnectionAddedBehavior],
    markElementDeletedBehavior: ['type', MarkElementDeletedBehavior],
    bpmnRenderer:    ['type', TrackingChangesRenderer],
    markNodeDeletedHandler: ['type', MarkNodeDeletedHandler],
    markConnectionDeletedHandler: ['type', MarkConnectionDeletedHandler]
};
